var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scr-tp-wrp only-mobile"},[(_vm.show && _vm.active)?_c('div',{staticClass:"scr-btn-wrp",on:{"click":function($event){return _vm.scrollTop()}}},[_c('img',{staticClass:"scr-icon",attrs:{"src":"/img/arrow_up_scroll.svg","alt":"arrow_up"}}),_vm._v(" "),_c('p',{staticClass:"scr-txt"},[_vm._v("Top")])]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529d9de5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/layouts/MobileScrollUp.vue
// module id = 560
// module chunks = 187